module.exports = __webpack_public_path__ + "img/excel_verde.33b2cc23.svg";